module.exports = __webpack_public_path__ + "img/gorilla.ae69de37.jpeg";